import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { ResponsiveLine } from '@nivo/line';
import { pixify, isPresent } from '@seedlang/utils';
import { computed } from 'mobx';

const Wrapper = styled.div`
  width: 100%;
`;

const ChartWrapper = styled.div`
  position: relative;
  height: ${props => props.height};
  width: 100%;
`;

@observer
class LineChart extends React.Component {

  static defaultProps = {
    height: 400,
  };

  @computed get tickValues() {
    const maxTicks = 25;
    const dataPoints = this.props.data?.[0]?.data || [];
    const step = Math.ceil(dataPoints.length / maxTicks);
    return dataPoints.filter((_, i) => i % step === 0).map(p => p.x);
  }

  render() {
    return (
      <Wrapper>
        {
          isPresent(this.props.data) &&
            <ChartWrapper
              height={pixify(this.props.height)}
            >
              <ResponsiveLine
                data={this.props.data}
                margin={{
                  top: 10,
                  right: 20,
                  bottom: 80,
                  left: 40,
                }}
                height={this.props.height}
                colors={x => x.color}
                minY='auto'
                stacked={false}
                curve='linear'
                enableGridX={false}
                lineWidth={3}
                dotSize={7}
                dotColor='inherit:darker(0.3)'
                dotBorderWidth={2}
                dotBorderColor='#efefef'
                animate={true}
                enableTouchCrosshair={true}
                useMesh={true}
                axisBottom={{
                  orient: 'bottom',
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: -90,
                  legendOffset: 36,
                  legendPosition: 'middle',
                  tickValues: this.tickValues,
                }}
                enableSlices='x'
                sliceTooltip={({ slice }) => {
                  const date = slice.points[0].data.xFormatted;
                  const valueSets = slice.points.map(point => [point.serieId, point.color, point.data.y]);
                  return <div style={{ backgroundColor: 'white', padding: '5px 10px', borderRadius: '5px', fontSize: '12px' }} >
                    <strong>
                      {date}
                    </strong>
                    {valueSets.map(valueSet => {
                      return <div key={valueSet[0]} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ backgroundColor: valueSet[1], width: '10px', height: '10px' }} />
                        {valueSet[0]}: {valueSet[2]}
                      </div>;
                    })}
                  </div>;
                }}
              />
            </ChartWrapper>
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(LineChart);
